import React, { useEffect, useState } from 'react';
import InfoPanel from './InfoPanel/InfoPanel';
import VerticalInvestmentSlider from './VerticalInvestmentSlider/VerticalInvestmentSlider';
import PlansChart from './PlansChart/PlansChart';
import { findPreferredPlanByAmount, formatAmount, getAmountForPlan, planCoversAmount } from './util';
import { ISubscription } from '@/services/SubscriptionService';
import { Spinner, SpinnerSize } from '@fluentui/react';

type TSuscripcionSelectorProps =
{
    subscriptions: ISubscription[];
    selectedPlan: ISubscription;
    currentAmount: number;
    setSelectedPlan: (plan: ISubscription) => void;
}

const BASE_CLASS = "suscriptionSelector";

export const SuscripcionSelector: React.FC<TSuscripcionSelectorProps> = ({ subscriptions, selectedPlan, currentAmount, setSelectedPlan }: TSuscripcionSelectorProps) =>
{
    const [amount, setAmount] = useState<number>(currentAmount ?? 0);

    useEffect(() =>
    {
        setAmount(currentAmount ?? 0);
    }, [currentAmount]);

    // Si el plan actual deja de cubrir el importe (o ya no está ofertado),
    // se elige el de mayor límite finito. Si sigue cubriendo, se respeta la pulsación (p. ej. Mini).
    useEffect(() =>
    {
        if(!subscriptions?.length)
        {
            return;
        }

        const selectedIsOffered = subscriptions.some((plan) => plan.id === selectedPlan?.id);
        const selectedStillCovers = selectedIsOffered && planCoversAmount(selectedPlan, amount);
        if(selectedStillCovers)
        {
            return;
        }

        const preferred = findPreferredPlanByAmount(amount, subscriptions);
        if(preferred && preferred.id !== selectedPlan?.id)
        {
            setSelectedPlan(preferred);
        }
    }, [amount, subscriptions, selectedPlan, setSelectedPlan]);

    const handlePlanClick = (planId: number) =>
    {
        const plan = subscriptions?.find(p => p.id === planId);
        if(!plan)
        {
            return;
        }
        setSelectedPlan(plan);

        const newAmount = getAmountForPlan(plan);
        setAmount(newAmount);
    }

    return(
        <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}__suscriptionTitle`}>
                {subscriptions.length > 1 ? "Selecciona la suscripción" : "Esta será tu nueva suscripción"}
            </div>
            <div className={`${BASE_CLASS}__containerWrapper`}>
                <div className={`${BASE_CLASS}__suscriptionWrapper`}>
                    <div className={`${BASE_CLASS}__investmentAmount`}>
                        <h3 className={`${BASE_CLASS}__verticalText`}>Su inversión</h3>
                        <span>Deseada: <strong>{formatAmount(amount)}</strong></span>
                        <p>Desliza arriba y abajo para seleccionar el valor de la inversión con la que vas a operar en tu cartera.</p>
                    </div>
                    <VerticalInvestmentSlider
                        amountState={amount}
                        onChange={setAmount}
                    />
                    {!subscriptions ? <Spinner size={SpinnerSize.large} /> :
                        <PlansChart subscriptions={subscriptions} selectedPlan={selectedPlan}
                            onPlanClick={handlePlanClick}
                        />
                    }
                    <div className={`${BASE_CLASS}__infoPanelWrapper`}>
                        <InfoPanel selectedPlan={selectedPlan} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuscripcionSelector;